/*
  COREEX size finder — the "Find my size" box inside the size-chart modal.

  Reads size ranges from the data-sizes attribute (one row per size,
  "SIZE|HIP min-max|WAIST min-max"), and on input suggests a size from the hip and
  waist measurements. It picks the first size whose max covers the value (so a
  measurement between two sizes rounds UP), computes that for hip and waist
  independently, and takes the LARGER of the two — matching the "choose the larger
  size" guidance. Below the smallest range → smallest size; above the largest →
  largest size.

  Self-contained: it queries its own inputs, so the same element can render in both
  the drawer and the popover with no id collisions.
*/
(function () {
  'use strict';

  function parseRanges(raw) {
    return (raw || '')
      .split(/\r?\n/)
      .map(function (line) {
        var parts = line.split('|');
        if (parts.length < 3) return null;
        var hip = parts[1].split('-');
        var waist = parts[2].split('-');
        var r = {
          size: parts[0].trim(),
          hipMax: parseFloat(hip[1] != null ? hip[1] : hip[0]),
          waistMax: parseFloat(waist[1] != null ? waist[1] : waist[0])
        };
        if (!r.size || isNaN(r.hipMax) || isNaN(r.waistMax)) return null;
        return r;
      })
      .filter(Boolean);
  }

  // Index of the first range whose max is >= value; falls through to the last
  // range when the value is above every range.
  function indexFor(value, ranges, key) {
    for (var i = 0; i < ranges.length; i++) {
      if (value <= ranges[i][key]) return i;
    }
    return ranges.length - 1;
  }

  var SizeFinder = class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.ranges = parseRanges(this.getAttribute('data-sizes'));
      this.hip = this.querySelector('[data-cx-hip]');
      this.waist = this.querySelector('[data-cx-waist]');
      this.result = this.querySelector('[data-cx-result]');
      this.sizeEl = this.querySelector('[data-cx-size]');

      var self = this;
      [this.hip, this.waist].forEach(function (el) {
        if (el) el.addEventListener('input', function () { self.update(); });
      });
    }

    update() {
      if (!this.ranges || !this.ranges.length) return;

      var hip = parseFloat(this.hip && this.hip.value);
      var waist = parseFloat(this.waist && this.waist.value);

      // Only suggest once both measurements are present and positive.
      if (isNaN(hip) || isNaN(waist) || hip <= 0 || waist <= 0) {
        if (this.result) this.result.hidden = true;
        return;
      }

      var idx = Math.max(
        indexFor(hip, this.ranges, 'hipMax'),
        indexFor(waist, this.ranges, 'waistMax')
      );

      if (this.sizeEl) this.sizeEl.textContent = this.ranges[idx].size;
      if (this.result) this.result.hidden = false;
    }
  };

  if (!window.customElements.get('coreex-size-finder')) {
    window.customElements.define('coreex-size-finder', SizeFinder);
  }

  /*
    Newsletter-popup guard. Opening any Focal <modal-content> writes
    theme:popup-appeared to localStorage, which the newsletter popup uses for its
    "only once" check — so opening the size guide would suppress the newsletter.
    We snapshot that key when the size-guide link is clicked and restore it on the
    next tick (after the modal's own handler has run), so the size guide leaves it
    exactly as it found it.
  */
  var KEY = 'theme:popup-appeared';
  Array.prototype.forEach.call(document.querySelectorAll('.coreex-size-guide-link'), function (link) {
    link.addEventListener('click', function () {
      var prev;
      try { prev = localStorage.getItem(KEY); } catch (e) { return; }
      setTimeout(function () {
        try {
          if (prev === null) localStorage.removeItem(KEY);
          else localStorage.setItem(KEY, prev);
        } catch (e) {}
      }, 0);
    });
  });
})();
